import React, { memo } from 'react';

export const MobileAppLogoLegacy = memo(() => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61 61">
    <defs>
      <filter id="a" width="126.4%" height="126.4%" x="-13.2%" y="-9.4%" filterUnits="objectBoundingBox">
        <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2" />
        <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
      </filter>
      <rect id="b" width="53" height="53" rx="8" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(4 2)">
        <use fill="#000" filter="url(#a)" xlinkHref="#b" />
        <use fill="#FFF" xlinkHref="#b" />
      </g>
      <path fill="#42AD58" d="M13 41h34L30 24z" />
      <path
        fill="#000"
        d="M12.8 40l2.7-2.6-1-.8-1.6 1.6-3-3-.9 1 3.8 3.8zm1.1-7.1l.7.6 1.3-1.3.8.8-1.3 1.3.8.8 1.7-1.6.8.8-2.7 2.6-3.8-3.8 2.6-2.6.8.7-1.7 1.7zm8.6-2.4l-2.6-.7a1.6 1.6 0 00-.4-2 1.6 1.6 0 00-2.2.2l-2 2 4 3.7.9-1-3.1-3 .6-.6a.7.7 0 011 0 .7.7 0 010 1l-.6.5 3.3 1 1.1-1.1zm-1.8-6a2.7 2.7 0 012-.9 2.6 2.6 0 012 .9c.5.5.8 1.2.9 2a2.6 2.6 0 01-.9 1.9 2.7 2.7 0 01-2 .8 2.6 2.6 0 01-2-.9 2.6 2.6 0 01-.8-1.9 2.6 2.6 0 01.8-2zm.8.7c-.6.6-.4 1.3.3 2 .8.8 1.5 1 2.1.4.6-.6.4-1.3-.3-2-.7-.8-1.5-1-2.1-.4zm4.3-2.7l-.7-2.2 1.1-1.1 1 3.7 1.5 1.5-1 1-1.5-1.6-3.5-1 1-1.1 2.1.8zm17.8 13l3.9-3.7-1-1-3.9 3.7 1 1zM29 21l3-1.4-2.2 2.2.9.9 3.8-3.8-1.2-1.2-2.9 1.4 1.5-2.9-1.3-1.2-3.9 3.8 1 .9 2.1-2.2-1.4 3 .6.5zm6.7.6l-.7.6 1.5 1.5-.8.7-1.5-1.4-.8.8 1.8 1.8-.8.8-2.8-2.8 3.9-3.8 2.8 2.8-.8.7-1.8-1.7zm3.7 9.7l2.6 2.6.9-1-1.7-1.5 3-3-1-1-3.8 3.9zm10.4 2.6l-1.3 4 2.7-2.6.9 1-3.9 3.7-1.2-1.2 1-4.1h.1l-2.6 2.6-1-1 4-3.7 1.3 1.3zm-11.1-3.3l.7-2.6c.6.3 1.4.1 1.9-.4a1.5 1.5 0 00-.1-2.1l-2-2-4 3.7 1 1 3.2-3.1.7.7c.2.2.3.5.2.7a.7.7 0 01-.5.5.7.7 0 01-.7-.2l-.7-.7-.8 3.4 1 1z"
      />
    </g>
  </svg>
));
